import { useState, useEffect, useMemo } from "react";
import {
  Routes,
  Route,
  Navigate,
  useNavigate,
} from "react-router-dom";
import useRoutes from "./routes";
import RouteGuard from "./route.guard";
import { useUserInfo } from "./context/user";
import { useUsersContext } from "./context/usersContext";
import ContactToSupportModal from "./components/ContactToSupportModal";

export default function App() {
  // const { pathname } = useLocation();
  const routes = useRoutes();
  const navigate = useNavigate();
  const userActiveLocation = useUserInfo()[4]
  const { products, isHighestPlan } = useUsersContext()
  const activePlan = products?.find((item) => item?.activePlan === true)
  const [openLimitModal, setOpenLimitModal] = useState(false)

  window.addEventListener("message", (event) => {
    if (event.data.type === "GO_TO_AI_AGENT") {
      navigate("/app/ai-agents");
    }
  });

  useEffect(() => {
    const referrer = document.referrer;
    if (referrer.includes("onboarding.")) {
      // Handle logic if user is coming from "onboarding.com"
      // Add your specific handling here
    } else {
      // Handle other cases
    }
  }, []);

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data.action === "redirect-pricing") {
        if (userActiveLocation?.type === 'free' || (!activePlan?.isenable_account && !activePlan?.developer_plan) || isHighestPlan())
          setOpenLimitModal(true)
        else
          navigate("/app/settings", { state: { tab: "Pricing" } });
      }
      if (event.data.action === "redirect-team") {
        navigate("/app/settings", { state: { tab: "Team" } });
      }
      if (event.data.action === "redirect-ai-agents") {
        navigate("/app/ai-agents");
      }
    };
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }
      if (route.guard) {
        const { valid, redirect, state } = route.guard;
        return (
          <Route
            element={
              <RouteGuard valid={valid} redirect={redirect} state={state} />
            }
            key={route.key}
          >
            <Route exact path={route.route} element={route.component} />
          </Route>
        );
      }

      if (route.route) {
        return (
          <Route
            exact
            path={route.route}
            element={route.component}
            key={route.key}
          />
        );
      }

      return null;
    });
  return (
    // <Router>
    <>
      <Routes>
        {getRoutes(routes)}
        <Route path="*" element={<Navigate to="/auth/sign-in" />} />
      </Routes>
      <ContactToSupportModal isOpen={openLimitModal} onClose={() => setOpenLimitModal(false)} />
    </>
    //   </Router>
  );
}
